module.exports = __webpack_public_path__ + "static/media/oldKzn.1abb182c.jpg";